import { createContext, useContext } from "react";

export const HideButtonContext = createContext<boolean>(false);

export function useHideButton() {
    return useContext(HideButtonContext);
}
